import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as actions from '../actions/loginFormActions';
import * as appActions from '../actions/appActions';
import LoginForm from '../components/LoginForm';
import LoopbackHttp from '../businessLogic/LoopbackHttp';
import {setDashType} from '../businessLogic/userProfileHelper';
import { gettext, setLocale } from '../i18n/service';

export class LoginContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.submit = this.submit.bind(this);
    this.reset_password = this.reset_password.bind(this);
    this.props.appActions.showHeaderInfo(false);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.redirect) {
      if (localStorage.getItem('auth_token') === 'undefined') {
        this.props.appActions.endSpinner();
        // this.props.showMessage({
        //   message: gettext('INVALID-CREDS'),
        //   level: 'error'
        // });
      }
      setTimeout(() => {
        this.props.actions.resetState();
      }, 0);
      if (LoopbackHttp.isDispatcher) {
        window.location.replace(document.location.origin);
        return true;
      } else if (LoopbackHttp.isOperator) {
        return true;
      } else if (LoopbackHttp.isAdministrator) {
        return this.props.router.replace('/admindashboard');
      } else if (LoopbackHttp.isFleet) {
        return true;
      }
    }
    // if (nextProps.error) {
    //   this.props.showMessage({
    //     title: gettext('ERROR-OCCURED'),
    //     message: nextProps.error,
    //     level: 'error',
    //     autoDismiss: 10
    //   });
    // }
  }
  reset_password(e) {
    return this.props.router.replace('/reset');
  }
  submit(e) {
    this.props.appActions.startSpinner();
    e.preventDefault();
    const elems = Array.from(e.target.elements);
    let fields = elems.reduce((prev, curr) => {
      if (!curr.name) {
        return prev;
      }
      prev[curr.name] = curr.type === 'checkbox' ? curr.checked : curr.value;
      return prev;
    }, {});

    this.props.actions.submit(fields, (request) => {
      request.then((data) => {
        if (typeof data.user !== 'string') {
          setLocale(data.user.language);
          if(data.user.role == 'driver') {
            return this.props.showMessage({
              title: gettext('ERROR-OCCURED'),
              message:'This user type is not allowed to access the Web Application',
              level: 'error',
              autoDismiss: 10
            });
          } else {
            this.props.actions.onLoginSuccess(data);
            this.props.appActions.showHeaderInfo(true);
            if(data.user.dashboardType)
              setDashType(data.user.dashboardType);
            else
              setDashType('regular');
          }
        }
        else
          return this.props.showMessage({
            message: data.user,
            level: 'error'
          });
      })
      .catch((data) => {
        this.props.appActions.endSpinner();
        if(data.role === 'Dispatcher' && !data.active) {
          this.props.actions.onLoginFailed(gettext('ACCOUNT-NOT-ACTIVE'));
          let userData = { userId: data.userId, userType: data.role };
          this.props.appActions.resentEmailForDispatcherActivation(userData);
        }
        else if((data.message.indexOf("activation") >= 0) && (data.statusCode==401)){
          
          this.props.showMessage({
            title: gettext('ERROR-OCCURED'),
            message:data.message,
            level: 'error',
            autoDismiss: 10
          });
        }
        else
          this.props.showMessage({
            title: gettext('ERROR-OCCURED'),
            message:'Invalid credentials',
            level: 'error',
            autoDismiss: 10
          });
          // this.props.actions.onLoginFailed(gettext('Invalid credentials'));
      });
    });
  }
  render() {
    return (
      <LoginForm
        submit={this.submit}
        reset_password={this.reset_password}
        startSpinner={this.props.appActions.startSpinner}
      />
    );
  }
}
LoginContainer.propTypes = {
  actions: PropTypes.object.isRequired,
  redirect: PropTypes.bool,
  history: PropTypes.object,
  showMessage: PropTypes.func.isRequired
};
function mapStateToProps(state) {
  return {
    error: state.loginFormReducer.error,
    request: state.loginFormReducer.request,
    loading: state.loginFormReducer.loading,
    redirect: state.loginFormReducer.redirect,
    message: state.appReducer.message
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
    appActions: bindActionCreators(appActions, dispatch)
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginContainer);



// WEBPACK FOOTER //
// ./src/containers/LoginContainer.js